import { LayoutService } from '../service/layout.service';
import { CommonModule } from '@angular/common';
import { Component, computed, ElementRef, inject, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppBreadcrumb } from './app.breadcrumb';
import { HeaderComponent } from '../../modules/base/header/header.component';

@Component({
  selector: '[app-topbar]',
  standalone: true,
  imports: [RouterModule, CommonModule, AppBreadcrumb, HeaderComponent],
  template: `<div class="layout-topbar">
    <div class="topbar-left">
      <a
        tabindex="0"
        #menubutton
        type="button"
        class="menu-button"
        (click)="onMenuButtonClick()"
      >
        <i class="pi pi-bars"></i>
      </a>
      <div app-breadcrumb></div>
    </div>

    <div class="topbar-right">
      <app-header></app-header>
    </div>
  </div>`
})
export class AppTopbar {
  layoutService = inject(LayoutService);

  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

  @ViewChild('menubutton') menuButton!: ElementRef;

  onMenuButtonClick() {
    this.layoutService.toggleMenu();
  }
}
